import {
  Box, BoxProps, Typography, TypographyProps,
} from '@mui/material';
import React from 'react';
import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';

const ConfirmationDescriptionWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  padding: '16px',
  [theme.breakpoints.up('sm')]: {
    padding: '32px',
  },
}));

const BodyTypography = styled(Typography)<TypographyProps>((props) => ({
  paddingTop: '0.5em',
  paddingBottom: '0.5em',
}));

export function CongratulationsDescription() {
  return (
    <ConfirmationDescriptionWrapper data-testid="descriptionWrapper">
      <Typography
        variant="h4"
        align="center"
        color="primary"
        mb={5}
        gutterBottom
        data-testid="descriptionTypo"
        sx={{ fontWeight: 'bold' }}
      >
        <FormattedMessage id="congratulations.header" />
      </Typography>
      <BodyTypography variant="body1" data-testid="descriptionTypo">
        <FormattedMessage id="congratulations.p1" />
        <ul>
          <li><FormattedMessage id="congratulations.p2" /></li>
          <li><FormattedMessage id="congratulations.p3" /></li>
        </ul>
      </BodyTypography>
    </ConfirmationDescriptionWrapper>
  );
}
